import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';
import { ItineraryTimelineModule } from '@fcom/common-booking/components/itinerary/itinerary-timeline.module';

import { TimetableLocationsService } from '../../services/timetable-locations.service';
import { TimetableScheduleComponent } from './timetable-schedule.component';
import { TimetableSchedulePanelComponent } from './timetable-schedule-panel.component';

/**
 * Just the presentational schedule + panel, split out of TimetableModule so the city-to-city
 * pages can use them without pulling in the whole timetable page (store, effects, routes).
 */
@NgModule({
  imports: [CommonModule, UiComponentsModule, UiTranslateModule, ItineraryTimelineModule],
  declarations: [TimetableScheduleComponent, TimetableSchedulePanelComponent],
  providers: [TimetableLocationsService],
  exports: [TimetableScheduleComponent, TimetableSchedulePanelComponent],
})
export class TimetableScheduleModule {}
